// extracted by mini-css-extract-plugin
export default {"buttons":"buttons--ux5HEB0zGY"};